import {PHASES, WAR_PHASE_STAGES} from "../../constants/phases";
import {selectPhase, selectWarPhaseStage} from "../../redux/reducers/sharedStateReducer/selectors";
import {selectSelectedUnitId} from "../../redux/reducers/privateStateReducer/selectors";

export const isUnitMovementMarkersShown = (state) => {
  const phase = selectPhase(state);
  const warPhaseStage = selectWarPhaseStage(state);
  const selectedUnitId = selectSelectedUnitId(state);

  return phase === PHASES.WAR
    && warPhaseStage === WAR_PHASE_STAGES.MOVEMENT
    && !!selectedUnitId;
}